import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Typography } from '@mui/material';
import { PoliciesEditor } from '../../../components/profileEditors/PoliciesEditor';

const PoliciesStep = ({ provider, setProvider, onFinish, onBack, onSkip }) => {
  return (
    <Box sx={{ maxWidth: '600px', margin: '0 auto' }}>
      <Typography variant="h4" sx={{ marginBottom: '20px' }}>
        Policies
      </Typography>

      {/* Policies editor */}
      <Box sx={{ marginBottom: '30px' }}>
        <PoliciesEditor provider={provider} setProvider={setProvider} showSaveButton={false} />
      </Box>

      {/* Bottom navigation */}
      <Box sx={{ display: 'flex', gap: '10px', justifyContent: 'space-between', marginTop: '40px' }}>
        <Button variant="outlined" onClick={onBack}>
          Back
        </Button>
        <Box sx={{ display: 'flex', gap: '10px' }}>
          <Button variant="text" onClick={onSkip}>
            Skip For Now
          </Button>
          <Button variant="contained" onClick={onFinish}>
            Finish
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

PoliciesStep.propTypes = {
  provider: PropTypes.object.isRequired,
  setProvider: PropTypes.func.isRequired,
  onFinish: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onSkip: PropTypes.func.isRequired
};

export default PoliciesStep;
